if (!customElements.get('details-modal')) {
  class DetailsModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');

      this.detailsContainer.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
      this.querySelector('button[type="button"]').addEventListener(
        'click',
        this.close.bind(this)
      );

      this.summaryToggle.setAttribute('role', 'button');
    }

    isOpen() {
      return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open(event);
    }

    onBodyClick(event) {
      if (
        !this.contains(event.target) ||
        event.target.classList.contains('modal-overlay')
      )
        this.close(false);
    }

    onTouchStart(event) {
      this.touchStartY = event.touches[0].clientY;
      this.touchScroller = this.getScroller(event.target);
    }

    onTouchMove(event) {
      if (event.touches.length > 1) return;

      const scroller = this.touchScroller;
      if (!scroller) {
        event.preventDefault();
        return;
      }

      const deltaY = event.touches[0].clientY - this.touchStartY;
      const atTop = scroller.scrollTop <= 0;
      const atBottom =
        Math.ceil(scroller.scrollTop + scroller.clientHeight) >=
        scroller.scrollHeight;

      if ((atTop && deltaY > 0) || (atBottom && deltaY < 0))
        event.preventDefault();
    }

    getScroller(target) {
      if (!this.contains(target)) return null;

      for (let element = target; element && element !== this; element = element.parentElement) {
        const { overflowY } = getComputedStyle(element);
        if (
          (overflowY === 'auto' || overflowY === 'scroll') &&
          element.scrollHeight > element.clientHeight
        )
          return element;
      }

      return null;
    }

    open(event) {
      this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.onTouchStartEvent =
        this.onTouchStartEvent || this.onTouchStart.bind(this);
      this.onTouchMoveEvent =
        this.onTouchMoveEvent || this.onTouchMove.bind(this);
      event.target.closest('details').setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.addEventListener('touchstart', this.onTouchStartEvent, { passive: true });
      document.addEventListener('touchmove', this.onTouchMoveEvent, { passive: false });
      document.body.classList.add('overflow-hidden');

      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }

    close(focusToggle = true) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.removeEventListener('touchstart', this.onTouchStartEvent);
      document.removeEventListener('touchmove', this.onTouchMoveEvent);
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('details-modal', DetailsModal);
}
